import Device from '../../../constants/deviceSizes';
import { appConfig } from '../../../config/customization';

export default {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [Device.mobile]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'left'
    }
  },
  detail: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 20,
    [Device.mobile]: {
      marginTop: 0
    }
  },
  adheredMessage: {
    color: appConfig.colors.primaryButton
  },
  adhereMessage: {
    color: appConfig.colors.primaryButton
  },
  reverse: {
    flexDirection: 'row-reverse',
    padding: '1px 5px 0px',
    whiteSpace: 'nowrap'
  }
};
